import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import { FaCheckSquare } from "react-icons/fa";
import { MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import { flare } from "@flareapp/js";

const BusinessView = () => {
  const userDetails = useSelector((state) => state?.user?.userDetails);
  const navigate = useNavigate();
  const { businessId } = useParams();
  const [BusinessDetails, setBusinessDetails] = useState({});
  const getBusiness = async () => {
    try {
      const { data } = await api.get(endpoint.business + businessId);
      setBusinessDetails(data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business view", error);
    }
  };
  useEffect(() => {
    getBusiness();
    document.title = `${appConfig.name} - Business Details`;
  }, []);
  const isSuperAdmin = userDetails?.role === userRole.superAdmin;

  return (
    <div className="card p-3 m-md-3">
      <div>
        <label className="az-content-label">Manage Businesses</label>
        <span className="d-block py-2">Business Details</span>
      </div>
      <hr className="mt-0" />

      <h5 className="mt-3"> Business Information</h5>
      <Row lg={2} md={1} sm={1} xs={1} xl={1} xxl={1} className="mt-2">
        <Col className="row mb-2">
          <div className="col-5">Business Name:</div>
          <div className="col-7">: {BusinessDetails?.name || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Business ID:</div>
          <div className="col-7">: {BusinessDetails?.id || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Company Name:</div>
          <div className="col-7">: {BusinessDetails?.companyName || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Company Registration Number:</div>
          <div className="col-7">: {BusinessDetails?.registrationNumber || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Company Address Line 1</div>
          <div className="col-7">: {BusinessDetails?.address1 || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Company Address Line 2</div>
          <div className="col-7">: {BusinessDetails?.address2 || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Postcode</div>
          <div className="col-7">: {BusinessDetails?.postcode || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">City Name</div>
          <div className="col-7">: {BusinessDetails?.city || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">State</div>
          <div className="col-7">: {BusinessDetails?.state || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Country</div>
          <div className="col-7">: {BusinessDetails?.country || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Email Address</div>
          <div className="col-7">: {BusinessDetails?.email || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Phone Number</div>
          <div className="col-7">: {BusinessDetails?.phoneNumber || ""}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Logo</div>
          <div className="col-7">: {BusinessDetails?.logo ? <img src={BusinessDetails?.logo} height={50} alt="" /> : "N/A"}</div>
        </Col>
        <Col className="row mb-2">
          <div className="col-5">Logo (Short Version)</div>
          <div className="col-7">: {BusinessDetails?.logoShort ? <img src={BusinessDetails?.logoShort} height={50} alt="" /> : "N/A"}</div>
        </Col>
        {isSuperAdmin && (
          <Col className="row mb-2 mt-3">
            <div className="col-5">Account Specifications</div>
            <div className="col-7">
              <div disabled>
                <div>
                  <span className="d-inline-block me-2">
                    {BusinessDetails?.idleLogoutFot30Min ? <FaCheckSquare className="text-primary" /> : <MdOutlineCheckBoxOutlineBlank />}
                  </span>
                  30-minute time-out when idle
                </div>
                <div>
                  <span className="d-inline-block me-2">
                    {BusinessDetails?.multipleDeviceLogin ? <FaCheckSquare className="text-primary" /> : <MdOutlineCheckBoxOutlineBlank />}
                  </span>
                  Multiple active login sessions for single account
                </div>
                {/* <div>
                  <span className="d-inline-block me-2">
                    {BusinessDetails?.urlLogin ? (
                      <FaCheckSquare className="text-primary" />
                    ) : (
                      <MdOutlineCheckBoxOutlineBlank />
                    )}
                  </span>
                  Enable URL login (replaces password)
                </div> */}
                <div>
                  <span className="d-inline-block me-2">
                    {BusinessDetails?.isLimitedHosting ? <FaCheckSquare className="text-primary" /> : <MdOutlineCheckBoxOutlineBlank />}
                  </span>
                  Limited Hosting (2 Years)
                </div>
                <div>
                  <span className="d-inline-block me-2">
                    {BusinessDetails?.whiteLabelAccount ? <FaCheckSquare className="text-primary" /> : <MdOutlineCheckBoxOutlineBlank />}
                  </span>
                  White Label Account
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>

      <div className="row">
        <div className="col-md-12 d-flex justify-content-end">
          {userDetails?.role === userRole.superAdmin || userDetails?.role === userRole.businessAdmin ? (
            <Link to={`/business/edit/` + businessId} className="me-1">
              <Button type="primary">Edit</Button>
            </Link>
          ) : (
            ""
          )}
          <Button type="primary" className="bg-secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BusinessView;
